// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da4c0ade","239":"a9dba367","453":"1bc56258","455":"1a16d17a","884":"6f3b52f3"}[chunkId] + ".chunk.js";
};